import { OrNavbarProps } from '../or-navbar'
import { Dialog, DialogPanel } from '@headlessui/react'
import { AtButton, AtLink, AtLinkType, Cancel } from '../../atoms'
import { MouseEvent } from 'react'
import { MlMobileNavbarDropdown } from '../../molecules/ml-mobile-navbar-dropdown'

export type OrMobileMenuProps = Pick<OrNavbarProps, 'logo' | 'links' | 'buttons'> & {
  open: boolean
  onClose: () => void
  onLogoClick?: (event?: MouseEvent<HTMLAnchorElement>) => void
}

export const OrMobileMenu = ({ buttons, links, onLogoClick, logo: { alt, src }, onClose, open }: OrMobileMenuProps) => (
  <Dialog open={open} onClose={onClose}>
    <DialogPanel className="fixed inset-0 bg-neutrals-white lg:hidden z-50">
      <div className="flex items-center justify-between h-[4.5rem] border-b-1 border-neutrals-300 px-4 py-2">
        <a
          onClick={onLogoClick}
          href="/"
          className="focus:outline-none focus-visible:outline-offset-4 focus-visible:outline focus-visible:outline-1 focus-visible:outline-neutrals-900"
        >
          <img alt={alt} src={src} width={1914} height={737} className="w-[4.5rem]" />
        </a>
        <button
          onClick={onClose}
          aria-label="Close mobile menu"
          className="focus:outline-none focus-visible:outline focus-visible:outline-1 focus-visible:outline-neutrals-900 focus-visible:outline-offset-4"
        >
          <Cancel className="w-10 h-10 p-2" />
        </button>
      </div>
      <div className="h-[calc(100%-4.5rem)] px-6 pb-5 flex flex-col justify-between">
        <nav className="grow flex flex-col gap-8 py-16 overflow-y-auto">
          {links?.map((link, i) => {
            if (link.type === 'dropdown') {
              return <MlMobileNavbarDropdown key={i} title={link.title} dropdownLinks={link.dropdownLinks} />
            }
            return (
              <AtLink
                key={i}
                onClick={link.onTrackClick}
                actionTarget={link.href}
                title={link.label}
                target={link.target}
                type={AtLinkType.SECONDARY}
                skipDefaultAlignment
              />
            )
          })}
        </nav>
        <div className="flex flex-col gap-2">
          {buttons?.map((button, i) => (
            <AtButton key={i} {...button} className="w-full" parentName="OrMobileMenu" />
          ))}
        </div>
      </div>
    </DialogPanel>
  </Dialog>
)
